import apiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getFeatureFlags = (token, id = "") => {
    return fetch(`${apiUrl}feature_flags/${id}`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}

export default getFeatureFlags